import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { CabTabService } from "./cab-tab.service";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-cab-tab",
  templateUrl: "./cab-tab.component.html",
  styleUrls: ["./cab-tab.component.scss"],
  standalone: true,
  imports: [NgClass, TranslateModule],
})
export class CabTabComponent {
  @Input() routes: string[] = [];
  @Input() class = "";
  @Output() changeStep = new EventEmitter<number>();
  @Input() titles: string[] = [
    "LANG_TAB.UZ",
    "LANG_TAB.UZ_CYRL",
    "LANG_TAB.RU",
  ];

  _cabTabService = inject(CabTabService);

  onChangeStep(step: number) {
    this._cabTabService.changeStep(step);
    this.changeStep.emit(step);
  }
}
